/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listQueues.defs.js'
export { main as default } from './listQueues.defs.js'
